import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-link',
  templateUrl: 'link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  url: string;

  @Input()
  text: string;
}
